import { IsString, IsOptional, IsBoolean, IsUUID, MaxLength } from 'class-validator';

export class CreateDestructionProcessConfigRequestDto {
    /**
     * Reference to the warehouse detail for destruction
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsOptional()
    @IsUUID()
    warehouseDetailId?: string;

    /**
     * Whether destruction is approved by Q&C only
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    approvedByQncOnly?: boolean;

    @IsOptional()
    @IsString()
    approvedByQncOnlyComments?: string;

    /**
     * Is destruction approved by both Q&C and Client
     * @example false
     */
    @IsOptional()
    @IsBoolean()
    approvedByQncAndClient?: boolean;

    @IsOptional()
    @IsString()
    approvedByQncAndClientComments?: string;

    /**
     * Reference to warehouse damage report procedure
     * @example 'WH-DMG-REP-001'
     */
    @IsOptional()
    @IsString()
    @MaxLength(100)
    warehouseDamageReportRef?: string;

    /**
     * Details about product on hold reporting process
     * @example 'Products on hold require QCO approval for destruction'
     */
    @IsOptional()
    @IsString()
    productOnHoldReportDetails?: string;

    /**
     * Details about short-dated product reporting process
     * @example 'Short-dated products follow expedited destruction process'
     */
    @IsOptional()
    @IsString()
    shortDatedReportDetails?: string;

    /**
     * Whether certificate of destruction is required
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    certificateOfDestructionReq?: boolean;

    /**
     * Additional notes about destruction process configuration
     * @example 'Environmentally compliant destruction methods required'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
